import styled from "@emotion/styled";
import { Typography } from "@kaltura/ds-react-components";
import { NoKeywordResultsIllustration, NoResultsIllustration } from "@kaltura/mediaspace-shared-ui";
import { translate } from "@kaltura/mediaspace-shared-utils";
import { Spacer, StyledTypography } from "./styled-components";
import CreateChannelButton from "../../filters-section/CreateChannelButton";
import { useChannelsContext } from "../../ChannelsContext";

interface NoResultsProps {
    isKeywordSearch?: boolean;
}

const StyledNoResults = styled("div")({
    textAlign: "center",
});

/**
 * channels search - no results found
 */
export function NoResults(props: NoResultsProps) {
    const { isKeywordSearch = false } = props;

    const { allowCreateChannel } = useChannelsContext();

    return (
        <StyledNoResults>
            <div>
                {isKeywordSearch ? (
                    <NoKeywordResultsIllustration />
                ) : (
                    <NoResultsIllustration width={300} height={300} />
                )}
            </div>
            <Typography variant="h4">
                {isKeywordSearch ? translate("No matching results found") : translate("No content available yet")}
            </Typography>
            <Spacer />
            {isKeywordSearch && (
                <StyledTypography variant={"body1"}>
                    {translate("Consider using different keywords or adjusting the filter to see more results.")}
                </StyledTypography>
            )}

            {!isKeywordSearch && allowCreateChannel && <CreateChannelButton borderless={true} />}
        </StyledNoResults>
    );
}
